import React from "react";

import cowinEditImage from "../../../../../../images/cowinEdit.svg";

import "./DetailsCard.css";

const DetailsCard = ({ header = "", details = { firstRow: [], secondRow: [] }, showHeaderButton = false, _headerButtonClick = () => { } }) => {
  return <div className="details-card-outer-div">
    <div className="details-card-header">
      <div className="details-card-header-text">
        {header}
      </div>
      {showHeaderButton &&
        <img src={cowinEditImage} className="details-card-header-button" alt="edit cowin details" onClick={_headerButtonClick} />
      }
    </div>
    <div className="details-card-body">
      <div className="details-card-row bottom-margin">
        {
          details.firstRow.length > 0 && details.firstRow.map((item, index) => (
            item.text && <div key={`${item.id}-${index}`} className="details-card-row-item">
              <div className="details-card-row-item-title">{item.title}</div>
              <div className="details-card-row-item-text">{item.text}</div>
            </div>
          ))
        }
      </div>
      <div className="details-card-row">
        {
          details.secondRow.length > 0 && details.secondRow.map((item, index) => (
            item.text && <div key={`${item.id}-${index}`} className="details-card-row-item second-row">
              <div className="details-card-row-item-title">{item.title}</div>
              <div className="details-card-row-item-text">{item.text}</div>
            </div>
          ))
        }
      </div>
    </div>
  </div>
}

export default DetailsCard;